import consts from '../../../../services/metaData/consts';

class Countries {
    // eslint-disable-next-line class-methods-use-this
    activeCountriesTooltip(isAllCountries, activeCountries, showChinaCountriesTooltip, tagId = null, tagType = null) {
        let acTooltip = '';


        let countryNames = null;
        const chinaTooltip = 'Not active in China';
        if (isAllCountries && !showChinaCountriesTooltip) {
            return acTooltip;
        }
        if (Array.isArray(activeCountries)) {
            countryNames = activeCountries.map(
                (country) => country.countryName || country
            )
                .join(', ');

            if (showChinaCountriesTooltip) {
                acTooltip = chinaTooltip;
            } else if (activeCountries.length > 0) {
                acTooltip = `Active in ${countryNames}`;
            } else {
                acTooltip = `${tagId ? consts.TAG_TYPE_TO_NAME[tagType] : 'Instance'}
                        is not active in any of the group's countries`;
            }
        } else if (showChinaCountriesTooltip) {
            acTooltip = chinaTooltip;
        }

        return acTooltip;
    }
}


export default new Countries();
